var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.$route.name))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-0"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Aguarde... Em breve serão liberados os gráficos.")])])])
}]

export { render, staticRenderFns }